/* TBET — live price updates on PDP
 * Keeps the editorial price line and the "In den Warenkorb — €37,00"
 * CTA suffix in sync with the currently-selected variant.
 *
 * Listens for change events bubbling up from the variant picker
 * (variant-radios-mixed / variant-selects), reads the variant JSON
 * embedded by Dawn, and updates DOM nodes marked with data attributes:
 *   [data-tbet-price-amount]        → main price
 *   [data-tbet-price-compare]       → crossed-out compare price (if on sale)
 *   [data-tbet-price-ratio]         → markup ratio
 *   [data-tbet-price-compare-wrap]  → wrapper, hidden when not on sale
 *   [data-tbet-cta-price]           → CTA button price suffix
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    // Minimal Shopify money formatter — supports {{amount}}, {{amount_no_decimals}},
    // and {{amount_with_comma_separator}} which are the most common in DE shops.
    if (typeof cents !== 'number') return '';
    var value = cents / 100;
    var fmt = format || '€{{amount_with_comma_separator}}';

    function withDecimals(precision) {
      return value.toFixed(precision);
    }
    function withCommaSeparator() {
      return value.toFixed(2).replace('.', ',');
    }
    function noDecimals() {
      return Math.round(value).toString();
    }

    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommaSeparator())
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals())
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals(2));
  }

  function getVariants() {
    var script = document.querySelector(
      'variant-radios-mixed > script[type="application/json"], ' +
      'variant-radios > script[type="application/json"], ' +
      'variant-selects > script[type="application/json"]'
    );
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getCurrentVariant(variants) {
    var input = document.querySelector('input[name="id"]');
    if (!input || !input.value) return null;
    var id = parseInt(input.value, 10);
    return variants.find(function (v) { return v.id === id; }) || null;
  }

  function updateAll() {
    var variants = getVariants();
    if (!variants) return;
    var variant = getCurrentVariant(variants);
    if (!variant) return;

    // Money format from page (set by Liquid on the price section if present)
    var priceSection = document.querySelector('[data-tbet-price-section]');
    var moneyFormat = priceSection ? priceSection.getAttribute('data-money-format') : null;

    var formattedPrice = formatMoney(variant.price, moneyFormat);
    var formattedCompare = variant.compare_at_price
      ? formatMoney(variant.compare_at_price, moneyFormat)
      : null;

    // 1. Price line — main amount
    document.querySelectorAll('[data-tbet-price-amount]').forEach(function (el) {
      el.textContent = formattedPrice;
    });

    // 2. Price line — compare + ratio + wrapper visibility
    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    document.querySelectorAll('[data-tbet-price-compare-wrap]').forEach(function (wrap) {
      if (onSale) {
        wrap.removeAttribute('hidden');
      } else {
        wrap.setAttribute('hidden', '');
      }
    });
    if (onSale) {
      document.querySelectorAll('[data-tbet-price-compare]').forEach(function (el) {
        el.textContent = formattedCompare;
      });
      var ratio = Math.round((variant.compare_at_price / variant.price) * 10) / 10;
      document.querySelectorAll('[data-tbet-price-ratio]').forEach(function (el) {
        el.textContent = ratio.toString();
      });
    }

    // 3. CTA button — price suffix
    document.querySelectorAll('[data-tbet-cta-price]').forEach(function (el) {
      // Only update if the button is still showing add-to-cart (not sold out)
      el.textContent = ' — ' + formattedPrice;
    });
  }

  function init() {
    updateAll();

    // Variant change events bubble up. Dawn updates input[name=id] inside the
    // variant component before dispatching, so reading on change works.
    document.addEventListener('change', function (e) {
      var inVariantPicker = e.target.closest(
        'variant-radios-mixed, variant-radios, variant-selects'
      );
      if (inVariantPicker) {
        // Tiny defer to let Dawn finish writing the new variant id
        setTimeout(updateAll, 30);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
